import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

// 解决跳转路由与当前路由相同导致报错问题
const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

const originalReplace = Router.prototype.replace
originalReplace.replace = function replace (location) {
  return originalReplace.call(this, location).catch(err => err)
}

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: () => import('@/view/home/index')
    },
    {
      path: '/login/index', // 登录
      name: 'login',
      component: () => import('@/view/login/index')
    },
    {
      path: '/home/index', // 首页
      name: 'index',
      component: () => import('@/view/home/index')
    },
    {
      path: '/home/download', // 数据下载
      name: 'download',
      component: () => import('@/view/home/download')
    },
    {
      path: '/home/user', // 设置
      name: 'user',
      component: () => import('@/view/home/user')
    },
    {
      path: '/news/index', // 新闻
      name: 'news',
      component: () => import('@/view/news/index')
    },
    {
      path: '/news/details', // 新闻详情
      name: 'newsDetails',
      component: () => import('@/view/news/details')
    },
    {
      path: '/method/index', // 方法
      name: 'method',
      component: () => import('@/view/method/index')
    },
    {
      path: '/data/index', // 数据
      name: 'data',
      component: () => import('@/view/data/index')
    },
    {
      path: '/team/index', // 团队
      name: 'team',
      component: () => import('@/view/team/index')
    },
    {
      path: '/team/details', // 团队详情
      name: 'teamDetails',
      component: () => import('@/view/team/details')
    },
    {
      path: '/about/index', // 关于
      name: 'about',
      component: () => import('@/view/about/index')
    }
  ]
})


// WEBPACK FOOTER //
// ./src/router/router.js